"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayPaginationBarWithBasicItems = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _pagination = require("@clayui/pagination");

var _shared = require("@clayui/shared");

var _react = _interopRequireDefault(require("react"));

var _PaginationBar = _interopRequireDefault(require("./PaginationBar"));

var _excluded = ["activeDelta", "activePage", "alignmentPosition", "deltas", "disabledPages", "ellipsisBuffer", "hrefConstructor", "labels", "onDeltaChange", "onPageChange", "showDeltasDropDown", "spritemap", "totalItems"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultDeltas = [{
  label: 10
}, {
  label: 20
}, {
  label: 30
}, {
  label: 50
}];
var DEFAULT_LABELS = {
  paginationResults: 'Showing {0} to {1} of {2}',
  perPageItems: '{0} items',
  selectPerPageItems: '{0} items'
};

var ClayPaginationBarWithBasicItems = function ClayPaginationBarWithBasicItems(_ref) {
  var activeDelta = _ref.activeDelta,
      _ref$activePage = _ref.activePage,
      activePage = _ref$activePage === void 0 ? 1 : _ref$activePage,
      alignmentPosition = _ref.alignmentPosition,
      _ref$deltas = _ref.deltas,
      deltas = _ref$deltas === void 0 ? defaultDeltas : _ref$deltas,
      disabledPages = _ref.disabledPages,
      ellipsisBuffer = _ref.ellipsisBuffer,
      hrefConstructor = _ref.hrefConstructor,
      _ref$labels = _ref.labels,
      labels = _ref$labels === void 0 ? DEFAULT_LABELS : _ref$labels,
      onDeltaChange = _ref.onDeltaChange,
      _onPageChange = _ref.onPageChange,
      _ref$showDeltasDropDo = _ref.showDeltasDropDown,
      showDeltasDropDown = _ref$showDeltasDropDo === void 0 ? true : _ref$showDeltasDropDo,
      spritemap = _ref.spritemap,
      totalItems = _ref.totalItems,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  if (!activeDelta) {
    activeDelta = deltas[0].label;
  }

  var items = deltas.map(function (_ref2) {
    var href = _ref2.href,
        label = _ref2.label;
    var item = {
      href: href,
      label: (0, _shared.sub)(labels.selectPerPageItems, [String(label)])
    };

    if (!href) {
      item.onClick = function () {
        if (onDeltaChange) {
          onDeltaChange(label);
        }
      };
    }

    return item;
  });
  var totalPages = Math.ceil(totalItems / activeDelta);

  _react.default.useEffect(function () {
    if (_onPageChange && activePage > totalPages) {
      _onPageChange(1);
    }
  }, [totalPages]);

  return /*#__PURE__*/_react.default.createElement(_PaginationBar.default, otherProps, showDeltasDropDown && /*#__PURE__*/_react.default.createElement(_PaginationBar.default.DropDown, {
    alignmentPosition: alignmentPosition,
    items: items,
    trigger: /*#__PURE__*/_react.default.createElement(_button.default, {
      displayType: "unstyled"
    }, (0, _shared.sub)(labels.perPageItems, [activeDelta]), /*#__PURE__*/_react.default.createElement(_icon.default, {
      spritemap: spritemap,
      symbol: "caret-double-l"
    }))
  }), /*#__PURE__*/_react.default.createElement(_PaginationBar.default.Results, null, (0, _shared.sub)(labels.paginationResults, [(activePage - 1) * activeDelta + 1, activePage * activeDelta < totalItems ? activePage * activeDelta : totalItems, totalItems])), /*#__PURE__*/_react.default.createElement(_pagination.ClayPaginationWithBasicItems, {
    activePage: activePage,
    alignmentPosition: alignmentPosition,
    disabledPages: disabledPages,
    ellipsisBuffer: ellipsisBuffer,
    hrefConstructor: hrefConstructor,
    onPageChange: function onPageChange(page) {
      if (page && _onPageChange) {
        _onPageChange(page);
      }
    },
    spritemap: spritemap,
    totalPages: totalPages
  }));
};

exports.ClayPaginationBarWithBasicItems = ClayPaginationBarWithBasicItems;